import React from 'react';
import styles from './index.module.css';
import BackgroundImage from '../../assets/images/zogeregeld/greyheader.png';
import PageHeader from '../../components/species/pageHeader';
import ShipmentsSection from '../../components/species/shipmentsSection';
import OrderMenu from '../../components/organs/orderMenu';
import AuthenticationProvider from '../../components/utils/AuthenticationProvider';
import OrderProvider from '../../components/utils/OrderProvider';
import QuestionaireModal from '../../components/species/zogefixt/QuestionaireModal';
import SupportCasesSection from '../../components/species/SupportCasesSection';
import {Order} from '../../models/order';

const ZoGeregeldPage = () => {
    return (
        <div
            className={styles.container}
            style={{
                backgroundImage: `linear-gradient(0deg, white 0%, transparent 10%), url(${BackgroundImage})`,
            }}
        >
            <div className={styles.wrapper}>
                <AuthenticationProvider>
                    {bearer => {
                        return [
                            <OrderProvider key={'order-provider'}>
                                {order => {
                                    return (
                                        <div
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                width: '100%',
                                            }}
                                        >
                                            <PageHeader key={'header'} />
                                            <div
                                                className={styles.content}
                                                key={'content'}
                                            >
                                                <div key={'left'}>
                                                    <ShipmentsSection
                                                        order={order as Order}
                                                    />
                                                    <SupportCasesSection
                                                        bearer={bearer}
                                                    />
                                                </div>
                                                <div key={'right'}>
                                                    <OrderMenu />
                                                </div>
                                            </div>
                                            <QuestionaireModal
                                                key={'questionaire'}
                                                bearer={bearer}
                                                customerName={
                                                    order?.shippingAddress
                                                        ?.firstname
                                                }
                                            />
                                        </div>
                                    );
                                }}
                            </OrderProvider>,
                        ];
                    }}
                </AuthenticationProvider>
            </div>
        </div>
    );
};

export default ZoGeregeldPage;
